import React from 'react';
import classNames from 'classnames';

import Icon, { faChevronRight } from '~components/icon';

interface ComponentProps {
  expanded: boolean;
  /** The button's accessible name. */
  label: string;
  onToggle: () => void;
  dataCy?: string;
}

/** The chevron button that opens and closes a row's children. A 44px touch target. */
const TreeTableToggle: React.FC<ComponentProps> = ({ expanded, label, onToggle, dataCy }) => (
  <button
    type="button"
    className={classNames('tree-table-toggle', { expanded })}
    aria-expanded={expanded}
    aria-label={label}
    onClick={onToggle}
    data-cy={dataCy}
  >
    <Icon icon={faChevronRight} aria-hidden />
  </button>
);

/** Takes the toggle's place on rows without one, so labels stay aligned. */
export const TreeTableToggleSpacer: React.FC = () => <span className="tree-table-toggle-spacer" aria-hidden="true" />;

export default TreeTableToggle;
